<div class="stick-top">
  <mat-toolbar><mat-icon>data_object</mat-icon> Subnets</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/subnets/0">
      <mat-icon aria-label="Create a new Subnet">add</mat-icon>
      Create a new Subnet
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
      <tr>
        <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
          <div class="vbox">
            Company
            <micro-company-select [(companyId)]="filter.companyId" ></micro-company-select>
          </div>
        </th>
        <th><div class="vbox">Name<input [(ngModel)]="filter.name" /></div></th>
        <th><div class="vbox">Vlan ID<input [(ngModel)]="filter.vlanId" /></div></th>
        <th><div class="vbox">Description<input [(ngModel)]="filter.description" /></div></th>
        <th><div class="vbox">Network<input [(ngModel)]="filter.network" /></div></th>
        <th><div class="vbox">Subnet<input [(ngModel)]="filter.subnet" /></div></th>
        <th><div class="vbox">Subnet Mask<input [(ngModel)]="filter.subnetMask" /></div></th>
        <th><div class="vbox">Start IP<input [(ngModel)]="filter.startIP" /></div></th>
        <th><div class="vbox">End IP<input [(ngModel)]="filter.endIP" /></div></th>
        <th><div class="vbox">Gateway<input [(ngModel)]="filter.gateway" /></div></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of dataSource.data">
        <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
        <td>
          <a routerLink="/subnets/{{ element.id }}">{{ element.name }}</a>
        </td>
        <td>{{ element.vlanId }}</td>
        <td>{{ element.description }}</td>
        <td>{{ element.network }}</td>
        <td>{{ element.subnet }}</td>
        <td>{{ element.subnetMask }}</td>
        <td>{{ element.startIP }}</td>
        <td>{{ element.endIP }}</td>
        <td>{{ element.gateway }}</td>
      </tr>
      <tr *ngIf="dataSource.data?.length === 0">
        <td colspan="100"><em>No results found</em></td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="100">
          <mat-paginator
            #paginator
            (page)="reload()"
          ></mat-paginator>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
